<template>
  <f7-page v-if="!loadingCodeFlag">
      <div class="home-page-wrap">
        <!--
        <header-image></header-image>
        -->
        <div class="wave-header-oblique sticky-top">
          <img class="index-logo" src="../../images/logo/logo-all.png" alt="">
           <template v-if="checkLoadingImage !== undefined && checkLoadingImage !== ''" >
            <a href="/settings" class="index-profile-button"  v-bind:style="{'background-image':'url('+checkLoadingImage+')'}"></a>
           </template>
           <template v-else >
            <a href="/settings" class="index-profile-button" ></a> 
           </template>
        </div>
        <ul class="home-container">
        <!--
          <li>
            <f7-link href="/news">
              <img src="../../images/icon/megaphone.png" alt="">
              <div>
                <h3>推播訊息</h3>
                <p>推播訊息.</p>
              </div>
            </f7-link>
          </li>
-->
          <li>
            <f7-link href="/personal-default">
              <img src="../../images/icon/profile-account.png" />
              <div>
                <h3>個人資訊</h3>
                <p>填寫基本勵學所需資訊</p>
              </div>
            </f7-link>
          </li>

          <li>
            <f7-link href="/my-coin">
              <img src="../../images/icon/t-coin.png" />
              <div>
                <h3>我的培育歷程</h3>
                <p>依據各類勵學措施，完成後取得之勵學金。</p>
              </div>
            </f7-link>
          </li>

          <!--
          <li>
            <f7-link href="/coursework">
              <img src="../../images/icon/book.png">
              <div>
                <h3>課輔媒合</h3>
                <p>以學習取代工讀，同時兼顧課業與生活所需。</p>
              </div>
            </f7-link>
          </li>
          

          <li>
            <f7-link @click="checkHref('http://src.thu.edu.tw/')">
              <img src="../../images/icon/megaphone.png" alt="">
              <div>
                <h3>T幣相關活動</h3>
                <p>取得最新活動訊息，讓您的 T 幣更加豐富。</p>
              </div>
            </f7-link>
          </li>
          -->
        </ul>

  </div>
  </f7-page>

</template>

<script>
  import Service from '../../service';
  import HeaderImage from './header-image.vue';
  import { bus } from '../../js/bus.js';
  import axios from '../../js/axiosModule.js';
  import LoginErrorModal from "./LoginErrorModal";
  import 'swiper/dist/css/swiper.css'
  import { swiper, swiperSlide } from 'vue-awesome-swiper'

  export default {
    components: {
      'header-image':HeaderImage,
      swiper,
      swiperSlide
    },
    data() {
      return {
        swiperOption: {
          pagination: {
           el:'.swiper-pagination'
          },
          slidesPerView:1,
          autoplay:{
            delay:3000,
            disableOnInteraction:false,
          },
          spaceBetween:30,
        },
        checkLoadingImage:undefined,
       userInfo:undefined,
        loadingCodeFlag:false
      };
    },
    methods: {
      checkHref: function (linkText) {
          window.open(linkText);
      },
      checkAuth : function() {
        
        let self = this;
       
        if (self.$store.state.userInfo === undefined || self.$store.state.userInfo === null) {
            if (  self.$f7route.query !== undefined && 
                  self.$f7route.query.code !== undefined && 
                  self.$f7route.query.code !== "" ) {
                //self.$f7router.navigate("/login");
                self.loadingCodeFlag = true;
                axios.axiosGet(self.$app.axiosUrl+"/api/Authenticate/LoginOAuth2/"+self.$f7route.query.code).then((response) => {
                  console.dir(response);
                  
                  if (response.data.status == 200 ) {
                    self.userInfo = {};
                    self.userInfo.studentNo = response.data.data.studentNo;
                    self.userInfo.chineseName = response.data.data.chineseName;
                    self.userInfo.position = response.data.data.position;
                    self.userInfo.department = response.data.data.department;
                    self.userInfo.mobilePhone = response.data.data.mobilePhone;
                    self.userInfo.email = response.data.data.email;
                    self.userInfo.type = response.data.data.type;
                    self.userInfo.avatarPath = response.data.data.avatarPath;
                    self.localAavatarPath = response.data.data.avatarPath !== '' ? self.$app.cdnUrl + "/" + response.data.data.avatarPath : '';
                    self.$store.dispatch("authFlagTrigger",true);
                    self.$store.dispatch("tokenTrigger",response.data.data.token);
                    self.$store.dispatch("coachTrigger",response.data.data.coachType);
                    self.$store.dispatch("userTrigger", self.userInfo);
                  } else {
                    self.$dialog.modal({
                      component: LoginErrorModal,
                      title: "",
                      //showCloseBtn: this.checked,
                      params: { firstInput: "" },

                      callback: p => {
                        //self.$dialog.alert("已送出", { type: "success", showIcon: false });
                      // self.$f7router.navigate("/coin-detail");
                      // console.log("infor");
                      }
                    });
                  }
                  self.loadingCodeFlag = false;
                  
                },
                ex=> {
                  //exception here
                  //location.href = "https://oauth.thu.edu.tw/v1/index.php/oauth/authorize?response_type=code&client_id=Oa6N2SZeyHvZ9WNUbkBbpowcmWsPyD"
                  
                }).catch(err => function() {
                 
                });
              } else {
                //location.href = "https://oauth.thu.edu.tw/v1/index.php/oauth/authorize?response_type=code&client_id=Oa6N2SZeyHvZ9WNUbkBbpowcmWsPyD";
                self.$f7router.navigate("/login");
              }
        } else {
          self.userInfo = self.$store.state.userInfo;
          if (self.userInfo !== undefined && self.userInfo !== null ) {
            if (self.userInfo.avatarPath !== undefined &&
            self.userInfo.avatarPath !== null &&
            self.userInfo.avatarPath !== '') {
              self.checkLoadingImage = self.$app.cdnUrl + '/' + self.userInfo.avatarPath;
            } else {''
              self.checkLoadingImage = '';
            }
            
          
          }
        }
      },getBasicInforData:function() {
        let self = this;
        var params= {};
        params.access_token=self.$store.state.accessToken;
       
        axios.axiosPost(self.$app.oAuthUrl+"/oauth/me",params).then((response)=> {
          self.$store.dispatch("userTrigger",response.data);
       //   console.dir(response.data);
          self.getCoachTypeData();
        }).catch(err=>console.log(err));
      },getCoachTypeData: function() {
        let self = this;
        var params = {};
        params.queryType = "studentno";
        params.queryString = self.$store.state.userInfo.studentNo;
        params.coachType = 0;
        params.activeTime = self.getNowTime();
        params.canSearch = true;
        axios.axiosTokenPost(self.$app.axiosUrl + "/api/Coach/GetCoachStudent" , params).then((response) => {
          self.$store.dispatch("coachTrigger",response.data.data.coachType);
         // console.dir(response.data.data.coachType);
        }).catch(err => console.log(err));
      },
      getNowTime : function() {
        var today = new Date();
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var dateTime = date+'T'+time+'.000Z';
        return dateTime;
      }

    },
    mounted() {
    },
    created() {
      let self = this;
      self.checkAuth();
      bus.$on('homeBus',function(res){
        //console.log(res);
        self.checkLoadingImage = res.avatarPath;
      });
    },
  };
</script>




// WEBPACK FOOTER //
// src/pages/home/index.vue